// extracted by mini-css-extract-plugin
module.exports = {"a-button":"Button_a-button__nozff","-wide":"Button_-wide__mdU3q"};